import React, { useRef } from 'react';
import styled from 'styled-components';
import { Button } from './Buttons';
import { Text } from './Typography';

const FileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const FileInputButton = styled(Button)`
  align-self: flex-start;
`;

const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.sm};
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.small};
`;

const FileInput = ({ 
  id, 
  accept, 
  onChange, 
  disabled, 
  buttonText = "Choose File",
  selectedFile,
  maxSizeInMB = 5
}) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check file size
    if (file.size > maxSizeInMB * 1024 * 1024) {
      alert(`File size must be less than ${maxSizeInMB}MB`);
      return;
    }

    onChange(file);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <FileInputContainer>
      <HiddenFileInput
        ref={fileInputRef}
        id={id}
        type="file"
        accept={accept}
        onChange={handleFileChange}
        disabled={disabled}
      />
      <FileInputButton
        type="button"
        variant="outline"
        onClick={handleButtonClick}
        disabled={disabled}
      >
        {buttonText}
      </FileInputButton>
      {selectedFile && (
        <FileInfo>
          <Text size="sm" style={{ margin: 0 }}>
            <strong>{selectedFile.name}</strong> ({formatFileSize(selectedFile.size)})
          </Text>
        </FileInfo>
      )}
    </FileInputContainer>
  );
};

export default FileInput;